import { render, staticRenderFns } from "./overlay-work-detail.vue?vue&type=template&id=7c1dd2bc"
import script from "./overlay-work-detail.vue?vue&type=script&lang=js"
export * from "./overlay-work-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports